<template>
    <!--<div class="profile-page container">-->
    <!--</div>-->
    <div class="profile-page container d-flex align-items-center">
        <vue-headful
                title="Register - SIC Dashboard"
        />
        <div class="container-fluid align-items-center p-3">
            <div class="row justify-content-center">
                <div class="col-md-4">
                    <div class="card shadow border-0">
                        <div class="card-header border-0 text-center bg-transparent">
                            <div class="text-center mt-2 pt-2">
                                <h3>User Profile </h3>
                            </div>
                        </div>
                        <div class="card-body">
                            <form role="form">
                                <div class="form-group mb-3">
                                    <div class="input-group input-group-alternative">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="ni ni-single-02"></i></span>
                                        </div>
                                        <input v-model="fullName" v-validate="'required|min:3|max:30'" name="fullName"
                                               data-vv-as="First Name" class="form-control" placeholder="Full Name"
                                               type="text">
                                    </div>
                                    <small v-if="errors.has('fullName')" class="text-danger">
                                        {{ errors.first('fullName') }}
                                    </small>
                                </div>
                                <div class="form-group mb-3">
                                    <div class="input-group input-group-alternative">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="ni ni-email-83"></i></span>
                                        </div>
                                        <input v-model="email" v-validate="'required|email'" name="email"
                                               data-vv-as="Email" class="form-control" placeholder="Email" type="email">
                                    </div>
                                    <small v-if="errors.has('email')" class="text-danger">
                                        {{ errors.first('email') }}
                                    </small>
                                </div>
                                <div class="form-group mb-3">
                                    <div class="input-group input-group-alternative">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="ni ni-single-02"></i></span>
                                        </div>
                                        <input v-model="username" v-validate="'required|min:3|max:15'" name="username"
                                               data-vv-as="Username" class="form-control" placeholder="Username"
                                               type="text">
                                    </div>
                                    <small v-if="errors.has('username')" class="text-danger">
                                        {{ errors.first('username') }}
                                    </small>
                                </div>
                                <div class="form-group mb-3">
                                    <div class="input-group input-group-alternative">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="ni ni-lock-circle-open"></i></span>
                                        </div>
                                        <input v-model="password" v-validate="'required|min:6|max:12'" name="password"
                                               data-vv-as="Password" class="form-control" placeholder="Password"
                                               type="password">
                                    </div>
                                    <small v-if="errors.has('password')" class="text-danger">
                                        {{ errors.first('password') }}
                                    </small>
                                </div>
                                <div class="text-center">
                                    <button type="button" class="btn btn-primary btn-block my-4">
                                        <i :class="{'loader': loading}"></i> Update
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import vueHeadful from "vue-headful";

export default {
  data() {
    return {
      loading: false,
      fullName: "Vijay",
      email: "Vijay@bothofus.se",
      username: "Vijay025",
      password: "123456"
    };
  },
  methods: {
    clearFields() {
      this.fullName = "";
      this.email = "";
      this.username = "";
      this.password = "";
    }
  },
  components: {
    "vue-headful": vueHeadful
  }
};
</script>
<style lang="scss">
.profile-page {
  padding-top: 50px;
}
</style>
